import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  // Monitor window scroll position to toggle back-to-top button
  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollBtn(true);
      } else {
        setShowScrollBtn(false);
      }
    };

    window.addEventListener('scroll', checkScroll, { passive: true });
    return () => window.removeEventListener('scroll', checkScroll);
  }, []);

  const scrollToTopSmooth = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {showScrollBtn && (
        <button
          type="button"
          onClick={scrollToTopSmooth}
          aria-label="Scroll til toppen af siden"
          className="fixed bottom-6 right-6 z-40 p-3.5 rounded-full bg-[#264A35] text-white shadow-xl hover:bg-[#1A3626] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#264A35] transition-all duration-300 transform hover:scale-110 active:scale-95 flex items-center justify-center group"
        >
          <i className="fa-solid fa-arrow-up text-base transition-transform group-hover:-translate-y-0.5" aria-hidden="true" />
          <span className="sr-only">Scroll til toppen</span>
        </button>
      )}
    </>
  );
}
